module.exports = __webpack_public_path__ + "static/down.2429d2cb.svg";